import { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { theme } from '../../themes/theme'
import { FlexColumn } from '../styles/Containers'
import { allSettingsSections } from '../../routes/settingsRoutes'
import SettingsMenuSection from './SettingsMenuSection'

const MenuRail = styled.div`
  align-self: stretch;
  min-width: min-content;
`

const StickyMenuContent = styled(FlexColumn)`
  position: sticky;
  top: 20px;

  background: ${theme.colors.background.light};
  border-radius: ${theme.borderRadius.div};
  min-height: ${props => `${props.minheight}px`};
  gap: 15px;
  padding: 10px;
`

function SettingsMenu({ sections = allSettingsSections }) {
  const stickyRef = useRef(null)
  const [stickyHeight, setStickyHeight] = useState(0)

  function handleScroll() {
    if (stickyRef.current) {
      const rect = stickyRef.current.getBoundingClientRect()
      const top = Math.max(rect.top, 20)
      const viewportHeight = window.innerHeight
      // 40 accounts for the 20px space above and below the menu
      const divHeight = viewportHeight - top - 40
      setStickyHeight(divHeight)
    }
  }

  useEffect(() => {
    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })
    window.addEventListener('resize', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleScroll)
    }
  }, [])

  return (
    <MenuRail>
      <StickyMenuContent ref={stickyRef} minheight={stickyHeight}>
        {Object.keys(sections).map(section => (
          <SettingsMenuSection key={section} {...sections[section]} />
        ))}
      </StickyMenuContent>
    </MenuRail>
  )
}

SettingsMenu.propTypes = {
  sections: PropTypes.object
}

export default SettingsMenu
